import type { RefObject } from 'react';

/**
 * Scrolls to first appearance of .formik-error-scroll-anchor
 * Doesn't bind to existing formik-field__error class to avoid mixing of concerns (style & functionality)
 * Consider dealying execution for cases when part of form is not rendered (and render it first)
 */
export const scrollErrorIntoView = (ref: RefObject<HTMLFormElement>): void => {
  const el = ref.current?.querySelector('.formik-error-scroll-anchor');

  (el?.parentElement ?? el)?.scrollIntoView();
};
